let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3A7mv")).then(() => parcelRequire('i6lc4'));